import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "components/common/Button";
import { clsx } from "clsx";

interface AddElementButtonProps {
  onClick: () => void;
  className?: string;
}

export const AddElementButton = ({
  onClick,
  className,
}: AddElementButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="primary"
      size="sm"
      onClick={onClick}
      startAdornment={<Plus className="w-3.5 h-3.5" />}
      className={clsx("shrink-0", className)}
    >
      {t("smartSurveyor.elementsCreation.addElement")}
    </Button>
  );
};
